import { apiRequest } from "../../index";
import config from "../../../../config";

const { VCHAT_API } = config;
const api = `${VCHAT_API}/users`;

// userId and meetingid needed in body
export async function updateUser(body) {
  try {
    const { userId } = body;
    const response = await apiRequest(`${api}/${userId}`, "PATCH", body);
    return response;
  } catch (err) {
    throw err;
  }
}
